import { useState, useEffect } from 'react';
import { getAbTestV2 } from 'dibs-buyer-layout/exports/clientABTestV2';

export const COLLECTIONS_CAP_TEST_NAME = 'Homepage_DynamicCollectionsCap_May2025';

export const useIsCollectionsCapTestVariant = (): boolean => {
    const [variant, setVariant] = useState(false);

    useEffect(() => {
        setVariant(getAbTestV2(COLLECTIONS_CAP_TEST_NAME)?.variant === 'variant');
    }, []);

    return variant;
};
